import {AfterViewInit, Component, ElementRef, Input, OnInit, OnDestroy, Renderer2, ViewChild} from '@angular/core';
import {LotteriesService} from '../lotteries.service';
import * as globals from '../settings';
import {LoginService} from '../shared/navigation/login.service';
import {UserService} from '../_services/user.service';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {EventManager} from '@angular/platform-browser';
import {GameLauncherService} from '../_services/game-launcher.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {GetDeviceService} from '../_services/get-device.service';
import {TranslateService} from '@ngx-translate/core';
import {CurrencyPipe} from '@angular/common';
import {CurrencyService} from '../_services/currency.service';
import {JackpotConfigService} from '../_services/jackpotConfig.service';
import {GetPaymentMethodsService} from '../shared/paymentMethod/get-payment-methods.service';
import {ActionService} from '../_services/action.service';
import {ParamsService} from '../_services/params.service';
import {CartService} from '../_services/cart.service';

@Component({
    selector: 'app-fancy-dynamic-banner',
    templateUrl: './fancy-dynamic-banner.component.html',
    styleUrls: ['./fancy-dynamic-banner.component.scss'],
    providers: [CurrencyPipe]
})
export class FancyDynamicBannerComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('fancyBanner') fancyBanner: ElementRef;
    @ViewChild('fancyGrid') fancyGrid: ElementRef;
    @Input() page;
    @Input() mode;
    dataSuccesfull: boolean;
    panels_counter: number;
    percent_tabs: any[];
    banner_width: number;
    banner_margin: number;
    dynamicBanner: any;
    bannerData: any;
    currentItem: number;
    preventScrollByClick: boolean;
    preventScrollByHover: boolean;
    loop: number;
    disableEverything: boolean;
    preLoginGameStatus: boolean;
    preLoginGameId: any;
    preLoginGameBet: any;
    gameDisabled: boolean;
    isLoadingButton: boolean;
    disableButton: boolean;
    user: any;
    tbpulse: string;
    hideMenu: boolean;
    userData: any;
    iosLetGo: boolean;
    activePanel: number;
    showLoginSubscription: Subscription;
    toggleScratchContent: Subscription;
    startInstant: Subscription;
    afterRegistration: Subscription;
    toggleContent: boolean;
    isMobile: boolean;
    gameIsRunned: boolean;
    whichBanner: string;
    pageLanguage: string;
    onlyOnce: boolean;
    infScrlOnlyOnce: boolean;
    oldLang: string;
    holdBanner: boolean;
    @Input() banner: any;
    @Input() allScratch;
    globalListenFunc: Function;
    bgsForLazy: string[];
    scrollOrNotTmp: number;
    scrollOrNotBool: boolean;
    lastScrollTime: number;
    whichBullet: number;
    displayedBanner: number;
    isLoggedIn: boolean;
    userDetails: any[];
    recentlyPlayed: any[];
    sliderMode: number;
    gridMoveFor: number;
    stopAnimations: boolean;
    stopAnimationsIS: boolean;
    mobilePosition: number;
    preventTouch: boolean;
    isSafari: boolean;
    stopSafariAnimation: boolean;
    stopSafariAnimationHand: boolean;
    preventBannerWhenScroll: boolean;
    scrollSize: number;
    currentPosition: number;
    newPosition: number;
    newScrollLeft: number;
    stopAnimationsAfterInit: boolean;
    showLang: any;
    languageChange: any;
    device: any;
    os: string;
    onlyonce: boolean;
    changedCurrency: Subscription;
    currency: any;
    firstMove: boolean;
    allowAnimations: boolean;
    getPaymentMethodsSub: Subscription;
    gpmData: any;
    showCasinoWelcomeModal: boolean;
    brand = globals.brand;
    userNeedIncreaseBalance: Subscription;
    userShouldIncreaseBalance: boolean;
    actionSpinner: any;
    actionValueSpinner: any;
    endGameTrigger: Subscription;
    time: number;
    oldTime: number;
    fakeCart: boolean;
    getFakeCartSubscription: Subscription;
    thisIsNewUser: Subscription;
    freshRegistered: boolean;

    constructor(public lotteryService: LotteriesService,
                private loginService: LoginService,
                public userService: UserService,
                public subscriptionsService: SubscriptionsService,
                private renderer: Renderer2,
                private router: Router,
                public eventManager: EventManager,
                private gameLauncher: GameLauncherService,
                private deviceService: DeviceDetectorService,
                private getDeviceService: GetDeviceService,
                private translate: TranslateService,
                private currencyPipe: CurrencyPipe,
                private currencyService: CurrencyService,
                public getpmService: GetPaymentMethodsService,
                public jackpotConfig: JackpotConfigService,
                private actionService: ActionService,
                private paramsService: ParamsService,
                private cartService: CartService,
                private gpmService: GetPaymentMethodsService) {
        this.onlyonce = false;
        const date = new Date();
        this.lastScrollTime = date.getTime();
        this.stopAnimationsAfterInit = true;
        this.allowAnimations = false;
        this.iosLetGo = false;
        this.newScrollLeft = 0;
        this.preventBannerWhenScroll = false;
        this.preventTouch = false;
        this.stopAnimations = false;
        this.stopAnimationsIS = false;
        this.holdBanner = false;
        this.whichBullet = 1;
        this.gridMoveFor = 0;
        this.whichBanner = 'new';
        this.currentPosition = 0;
        this.onlyOnce = false;
        this.infScrlOnlyOnce = false;
        this.setSizes();
        this.eventManager.addGlobalEventListener('window', 'resize', this.onResize.bind(this));
        this.showLoginSubscription = this.subscriptionsService.getShowLogin().subscribe(showLogin => {
            if (this.dynamicBanner && this.dynamicBanner[0] && this.dynamicBanner[0].Name !== 'Scratchcards Special Banner') {
                this.getData();
            }
        });

        this.fakeCart = false;
        this.getFakeCartSubscription = this.subscriptionsService.getFakeCart().subscribe(fc => {
            this.fakeCart = fc;
        });

        this.toggleScratchContent = this.subscriptionsService.getToggleContent().subscribe(data => {
            const lang = localStorage.getItem('pageLanguage');
            if (data && this.oldLang !== lang) {

                this.getData();
            }
        });

        this.thisIsNewUser = this.subscriptionsService.getNewUser().subscribe(data => {
            if (data) {
                this.freshRegistered = true;
                this.checkIfShowCasinoWelcomeModal();
                setTimeout(() => {
                    this.freshRegistered = false;
                }, 500);
            } else {
                this.freshRegistered = false;
            }
        });

        this.user = this.subscriptionsService.getLoggedInStatus().subscribe(data => {
            if (data === true && this.isLoggedIn === false) {
                this.userDetails = this.userService.userData;
                if (this.userDetails) {
                    this.getMyPersonalArea(this.userDetails);
                    if (this.preLoginGameStatus) {
                        this.runGame(this.preLoginGameId, this.preLoginGameBet);
                    }
                }
            }
            this.isLoggedIn = data;

        });

        this.startInstant = this.subscriptionsService.getStartInstant().subscribe(data => {
            if (data === 'off') {
                this.gameIsRunned = false;
            } else {
                this.gameIsRunned = true;
            }
        });

        this.afterRegistration = this.subscriptionsService.getUserAfterRegistration().subscribe(
            data => {
                if (data) {
                    this.checkIfShowCasinoWelcomeModal();
                }
            }
        );

        this.endGameTrigger = this.subscriptionsService.getTriggeredEndGameSessionIG().subscribe(data => {
            this.actionSpinner = '';
            this.actionValueSpinner = '';
        });

        this.bgsForLazy = [];

        this.isSafariMeth();

        this.showLang = this.translate.currentLang;

        this.currency = this.currencyService.currency;
        this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                this.currency = currency;
            }
        });
        this.firstMove = false;

        this.getPaymentMethodsSub = this.subscriptionsService.getPaymentMethods().subscribe(gpm => {
            this.gpmData = gpm;
        });

        this.getpmService.getPaymentMethods();

        this.userShouldIncreaseBalance = false;
        this.userNeedIncreaseBalance = this.subscriptionsService.getUserNeedIncraseBalance().subscribe(data => {
            if (data && data !== -1 && window.location.href.indexOf('casino') <= -1) {
                this.userShouldIncreaseBalance = true;
            } else {
                this.userShouldIncreaseBalance = false;
            }
        });
    }

    ngOnInit() {
        this.getData();
        this.sliderMode = 2;
        this.disableEverything = false;
        this.actionSpinner = '';
        this.actionValueSpinner = '';
        this.languageChange = this.subscriptionsService.getLanguage().subscribe(lang => {
            this.showLang = lang;
        });
    }

    ngOnDestroy() {
        this.disableEverything = true;
        if (this.toggleScratchContent) {
            this.toggleScratchContent.unsubscribe();
        }
        if (this.showLoginSubscription) {
            this.showLoginSubscription.unsubscribe();
        }
        window.removeEventListener('resize', this.onResize.bind(this));
        if (this.globalListenFunc) {
            this.globalListenFunc();
        }
        if (this.user) {
            this.user.unsubscribe();
        }
        if (this.changedCurrency) {
            this.changedCurrency.unsubscribe();
        }
        if (this.getPaymentMethodsSub) {
            this.getPaymentMethodsSub.unsubscribe();
        }
        if (this.afterRegistration) {
            this.afterRegistration.unsubscribe();
        }
        if (this.userNeedIncreaseBalance) {
            this.userNeedIncreaseBalance.unsubscribe();
        }
        if (this.getFakeCartSubscription) {
            this.getFakeCartSubscription.unsubscribe();
        }
        if (this.thisIsNewUser) {
            this.thisIsNewUser.unsubscribe();
        }
    }

    isSafariMeth() {
        this.isSafari = false;
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1) {
            if (ua.indexOf('chrome') === -1) {
                this.isSafari = true;
                this.stopSafariAnimation = false;
            }
        }
    }

    getMyPersonalArea(user) {
        const howOften = 3; /* how often (in seconds) script can call endpoint? */
        this.time = Math.round(Date.now() / (howOften * 1000));
        if (this.time !== this.oldTime) {
            this.oldTime = this.time;
            const sendData = {};
            sendData['sessionId'] = user.sessionId;
            this.lotteryService
                .postData(globals.appDomain + '/InstantGames/myPersonalArea/' +
                    user.memberId + '/myPersonalArea_fdb.json',
                    this.lotteryService.getFormUrlEncoded(sendData))
                .subscribe(data => {
                    if (data.message[0]) {
                        this.recentlyPlayed = data.message;
                        this.isLoggedIn = true;
                    }
                });
        }
    }

    onResize() {
        this.setSizes();
        if ((this.isMobile && window.innerWidth >= 991) ||
            (!this.isMobile && window.innerWidth < 991)) {
            this.getData();
        }
    }

    setMobilePosition(where) {
        this.newScrollLeft = where;
        this.mobilePosition = -100 * ((this.newScrollLeft) / window.innerWidth);
        this.currentPosition = this.mobilePosition;

        if (!this.stopAnimationsIS && !this.stopAnimations) {
            setTimeout(() => {
                this.infinityScroll();
            }, 901);
        } else {
            this.infinityScroll();
        }
    }

    handleDragAndDrop() {
        let startPosition = -1;
        let mobileStartPosition = 0;
        let relativePosition = startPosition;
        let currentScrollPosition = this.newScrollLeft;
        let mobileCurrentScrollPosition = 0;
        let goToTop = false;
        let isUnderOrBelow = true;
        const doc = document.documentElement;
        let windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (window.innerWidth >= 991) {
            this.globalListenFunc = this.renderer.listen(this.fancyBanner.nativeElement, 'mousedown', e => {
                this.stopAnimations = true;
            });
            this.globalListenFunc = this.renderer.listen('document', 'mousemove', e => {
                if (this.holdBanner) {
                    this.stopSafariAnimationHand = true;
                    if (startPosition === -1) {
                        startPosition = e.screenX;
                    }
                    relativePosition = e.screenX - startPosition;
                    this.setMobilePosition(currentScrollPosition - relativePosition);
                } else {
                    setTimeout(() => {
                        this.stopSafariAnimationHand = false;
                    }, 300);
                    startPosition = -1;
                    currentScrollPosition = this.newScrollLeft;
                }
            });
            this.globalListenFunc = this.renderer.listen(this.fancyGrid.nativeElement, 'mouseout', e => {
                if (this.holdBanner && this.stopAnimations) {
                    isUnderOrBelow = true;
                    if (e.clientY > this.fancyGrid.nativeElement.offsetTop &&
                        e.clientY < (this.fancyGrid.nativeElement.offsetHeight + this.fancyGrid.nativeElement.offsetTop)) {
                        isUnderOrBelow = false;
                    }
                    if (isUnderOrBelow) {
                        this.centerCurrentElement();
                    }
                }
            });
            this.globalListenFunc = this.renderer.listen(this.fancyBanner.nativeElement, 'mouseup', e => {
                this.centerCurrentElement();
            });
        } else {
            if (!this.onlyonce) {
                this.onlyonce = true;
                this.renderer.listen('document', 'touchstart', e => {
                    mobileStartPosition = e.touches[0].screenX;
                    currentScrollPosition = 0;
                    windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
                    this.scrollSize = e.view.scrollY;
                    this.preventBannerWhenScroll = false;
                });
                this.globalListenFunc = this.renderer.listen('document', 'touchmove', e => {
                    if (e.view.scrollY - this.scrollSize > 50) {
                        this.preventBannerWhenScroll = true;
                    }
                    this.device = this.deviceService.getDeviceInfo();
                    this.os = this.device.os !== 'unknown' ? this.device.os : this.getDeviceService.getOS();
                    let additionalHeight = 0;
                    if (this.os === 'Android' || this.os === 'android') {
                        additionalHeight = 64 * 2; /* @todo: to średnie rozwiązanie, trzeba ogarnąc zmienny viewport w androidzie */
                    }
                    if (!this.preventBannerWhenScroll && e.touches[0] && e.touches[0].screenY &&
                        e.touches[0].screenY > this.fancyBanner.nativeElement.offsetParent.offsetTop &&
                        e.touches[0].screenY < (this.fancyBanner.nativeElement.offsetParent.offsetTop +
                            this.fancyBanner.nativeElement.offsetHeight + additionalHeight)) {
                        if (Math.abs(this.gridMoveFor) > (this.dynamicBanner.length - 3) &&
                            Math.abs(this.gridMoveFor) < (this.dynamicBanner.length * 2 + 2) &&
                            !this.preventTouch) {
                            const date = new Date();
                            this.lastScrollTime = date.getTime();
                            this.stopAnimations = true;
                            currentScrollPosition = (e.touches[0].screenX - mobileStartPosition);
                            if (currentScrollPosition > 0) {
                                mobileCurrentScrollPosition = (100 * this.gridMoveFor) +
                                    (100 * Math.abs(currentScrollPosition) / window.innerWidth);
                            } else {
                                mobileCurrentScrollPosition = (100 * this.gridMoveFor) -
                                    (100 * Math.abs(currentScrollPosition) / window.innerWidth);
                            }
                            this.mobilePosition = mobileCurrentScrollPosition;
                            if (Math.abs(currentScrollPosition) > 25) {
                                this.renderer.addClass(document.body, 'holdScroll');
                                this.renderer.setAttribute(document.body, 'style', 'top: -' + windowTop + 'px');
                                goToTop = true;
                            } else {
                                goToTop = false;
                            }
                        }
                    }
                });
                this.renderer.listen('document', 'touchend', e => {
                    let date = new Date();
                    this.lastScrollTime = date.getTime();
                    this.preventTouch = true;
                    setTimeout(() => {
                        date = new Date();
                        this.lastScrollTime = date.getTime();
                        this.handleMobileInfinityScroll();
                    }, 501);
                    setTimeout(() => {
                        this.preventTouch = false;
                    }, 1501);
                    this.stopAnimations = false;
                    if (currentScrollPosition > 100) {
                        this.gridMoveFor++;
                    } else if (currentScrollPosition < -100) {
                        this.gridMoveFor--;
                    }
                    mobileCurrentScrollPosition = (100 * this.gridMoveFor);
                    this.mobilePosition = mobileCurrentScrollPosition;
                    this.whichBulletShouldBe();
                    this.renderer.removeClass(document.body, 'holdScroll');
                    this.renderer.removeAttribute(document.body, 'style');
                    if (goToTop) {
                        goToTop = false;
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                    this.preventBannerWhenScroll = false;
                });
            }
        }
    }

    mobileGoToFirst() {
        this.stopAnimations = true;
        setTimeout(() => {
            this.gridMoveFor = (this.dynamicBanner.length) * -1;
            this.mobilePosition = (100 * this.gridMoveFor);
            this.isDisplayedBanner();
        }, 1);
        setTimeout(() => {
            this.stopAnimations = false;
        }, 50);
    }

    mobileGoToLast() {
        this.stopAnimations = true;
        setTimeout(() => {
            this.gridMoveFor = ((this.dynamicBanner.length * 2) - 1) * -1;
            this.mobilePosition = (100 * this.gridMoveFor);
            this.isDisplayedBanner();
        }, 1);
        setTimeout(() => {
            this.stopAnimations = false;
        }, 50);
    }

    handleMobileInfinityScroll() {
        if (this.mobilePosition === 100 * this.gridMoveFor) {
            if (Math.abs(this.gridMoveFor) >= (this.dynamicBanner.length * 2)) {
                this.mobileGoToFirst();
            } else if (Math.abs(this.gridMoveFor) <= (this.dynamicBanner.length - 1)) {
                this.mobileGoToLast();
            }
        }
        this.isDisplayedBanner();
    }

    autoTriggerLetGo() {
        setTimeout(() => {
            this.triggerLetGo();
        }, 500);
    }

    triggerLetGoIfYouCan() {
        if (!this.holdBanner) {
            this.triggerLetGo();
        } else {
            setTimeout(() => {
                this.triggerLetGoIfYouCan();
            }, 50);
        }
    }

    triggerLetGo() {
        const panel_width = this.banner_width + this.banner_margin;
        const fancyBannerScrollLeft = this.newScrollLeft;
        const fancyBannerScrollMiddle = fancyBannerScrollLeft + (window.innerWidth / 2);
        const items = [];
        let lowerAbs = this.bannerData.length * panel_width;
        let lower = this.bannerData.length * panel_width;
        let lowerIndex = 0;
        let tmp = 0;
        for (let n = 0; n < this.bannerData.length; n++) {
            items[n] = ((n + 1) * panel_width - (panel_width / 2));
            tmp = items[n] - fancyBannerScrollMiddle;
            if (lowerAbs > Math.abs(tmp)) {
                lowerAbs = Math.abs(tmp);
                lower = tmp;
                lowerIndex = n;
            }
        }
        this.smoothScroll(fancyBannerScrollLeft, lower);
        this.holdBanner = false;
    }

    smoothScrollIfYouCan(fancyBannerScrollLeft, lower) {
        if (!this.holdBanner) {
            this.smoothScroll(fancyBannerScrollLeft, lower);
        } else {
            setTimeout(() => {
                this.smoothScrollIfYouCan(fancyBannerScrollLeft, lower);
            }, 50);
        }
    }

    getData() {
        if (this.page) {
            const sendData = {};
            this.pageLanguage = localStorage.getItem('pageLanguage');
            if (!this.pageLanguage) {
                this.pageLanguage = 'en';
            }
            this.oldLang = this.pageLanguage;
            sendData['language'] = this.pageLanguage;
            sendData['page'] = this.page;
            if (window.innerWidth < 991) {
                this.isMobile = true;
                sendData['device'] = 'Mobile';
            } else {
                this.isMobile = false;
                sendData['device'] = 'Desktop';
            }
            const playerDetails = JSON.parse(localStorage.getItem('playerDetails'));
            if (playerDetails && playerDetails.MemberID) {
                sendData['loggedIn'] = true;
            } else {
                sendData['loggedIn'] = false;
            }
            this.lotteryService
                .postData(globals.appDomain + '/banner/carousel/bannerCarousel_' + this.page + '_' + sendData['device'] +
                    '_' + sendData['loggedIn'] + '.json', this.loginService.getFormUrlEncoded(sendData))
                .subscribe(
                    response => {
                        if (response.apiErrorMessage || response.status !== 200 || response.message.banners.length === 0) {
                            this.disableEverything = true;
                        } else {
                            response.message.banners.forEach(value => {
                                if (value.Name === 'Scratchcards Special Banner') {
                                    this.whichBanner = 'old';
                                    this.subscriptionsService.emitShowOldBanner(true);
                                } else {
                                    this.whichBanner = 'new';
                                    this.subscriptionsService.emitShowOldBanner(false);
                                }
                            });
                            if (this.whichBanner !== 'old') {
                                this.dynamicBanner = this.checkButtonGradientColor(response.message.banners);
                                /* @todo: isMobile not working */
                                if (this.dynamicBanner.length < 3 && window.innerWidth > 991) {
                                    this.dynamicBanner = this.trippleForInfinityScroll(this.dynamicBanner);
                                }
                                this.bannerData = this.trippleForInfinityScroll(this.dynamicBanner);
                                if (window.innerWidth < 991) {
                                    this.gridMoveFor = this.dynamicBanner.length * -1;
                                }
                                this.loop = +response.message.rotate;
                                this.panels_counter = this.bannerData.length;
                                this.percent_tabs = [];
                                this.preventScrollByClick = false;
                                this.preventScrollByHover = false;
                                this.autoLoop();
                                if (this.isMobile && this.loop > 0) {
                                    setTimeout(() => {
                                        this.runCarousel();
                                    }, 100);
                                    const bannerInterval = setInterval(() => {
                                        if (this.mobilePosition) {
                                            setTimeout(() => {
                                                this.stopAnimationsAfterInit = false;
                                                this.allowAnimations = true;
                                            }, 100);
                                            clearInterval(bannerInterval);
                                        }
                                    }, 500);
                                } else {
                                    setTimeout(() => {
                                        this.runCarousel();
                                    }, 100);

                                    const bannerIntervalDeskt = setInterval(() => {
                                        if (this.mobilePosition) {
                                            this.autoCenterCurrentElement();
                                            setTimeout(() => {
                                                this.stopAnimationsAfterInit = false;
                                            }, 100);
                                            setTimeout(() => {
                                                this.allowAnimations = true;
                                            }, 1000);
                                            clearInterval(bannerIntervalDeskt);
                                        }
                                    }, 100);

                                }
                                this.initLazyLoad();
                                this.handleDragAndDrop();

                                if (window.innerWidth < 991) {
                                    this.bannerData.map(banner => {
                                        if (banner.Url['en'] && banner.Url['en'] !== '') {
                                            banner.Url['en'] = this.replaceBr(banner.Url['en']);
                                        }
                                        if (banner.Url['vi'] && banner.Url['vi'] !== '') {
                                            banner.Url['vi'] = this.replaceBr(banner.Url['vi']);
                                        }
                                        if (banner.Url['id'] && banner.Url['id'] !== '') {
                                            banner.Url['id'] = this.replaceBr(banner.Url['id']);
                                        }
                                    });
                                }

                            }
                            if (window.innerWidth >= 991) {
                                this.autoCenterCurrentElement();
                            }
                        }
                    }
                );
        }
    }

    checkIfShowCasinoWelcomeModal() {
        if (this.freshRegistered) {
            this.showCasinoWelcomeModal = true;
        }
    }

    replaceBr(string) {
        return string.replace('<br>', '').replace('<br/>', '').replace('<br />', '');
    }

    checkButtonGradientColor(dynBanner) {
        dynBanner.map(db => {
            if (!db.ButtonGradientColor || db.ButtonGradientColor === '') {
                db.ButtonGradientColor = db.ButtonColor;
            }


            for (const index in db.ButtonText) {
                if (db.OnlinePrice && this.currency && this.currency.Code && db.OnlinePrice[this.currency.Code]) {
                    db.ButtonText[index] = this.handlePrice(db.ButtonText[index],
                        db.OnlinePrice[this.currency.Code], this.currency.Symbol, this.currency.Code);
                } else if (db.Amount && this.currency && this.currency.Code && db.Amount[this.currency.Code]) {
                    db.ButtonText[index] = this.handlePrice(db.ButtonText[index],
                        db.Amount[this.currency.Code], this.currency.Symbol, this.currency.Code);
                }
            }
            for (const index in db.BannerText) {
                if (db.OnlinePrice && this.currency && this.currency.Code && db.OnlinePrice[this.currency.Code]) {
                    db.BannerText[index] = this.handlePrice(db.BannerText[index],
                        db.OnlinePrice[this.currency.Code], this.currency.Symbol, this.currency.Code);
                } else if (db.Amount && this.currency && this.currency.Code && db.Amount[this.currency.Code]) {
                    db.BannerText[index] = this.handlePrice(db.BannerText[index],
                        db.Amount[this.currency.Code], this.currency.Symbol, this.currency.Code);
                }
            }
            for (const index in db.BannerTitle) {
                if (db.OnlinePrice && this.currency && this.currency.Code && db.OnlinePrice[this.currency.Code]) {
                    db.BannerTitle[index] = this.handlePrice(db.BannerTitle[index],
                        db.OnlinePrice[this.currency.Code], this.currency.Symbol, this.currency.Code);
                } else if (db.Amount && this.currency && this.currency.Code && db.Amount[this.currency.Code]) {
                    db.BannerTitle[index] = this.handlePrice(db.BannerTitle[index],
                        db.Amount[this.currency.Code], this.currency.Symbol, this.currency.Code);
                }
            }
            for (const index in db.Url) {
                if (db.OnlinePrice && this.currency && this.currency.Code && db.OnlinePrice[this.currency.Code]) {
                    db.Url[index] = this.handlePrice(db.Url[index],
                        db.OnlinePrice[this.currency.Code], this.currency.Symbol, this.currency.Code);
                } else if (db.Amount && this.currency && this.currency.Code && db.Amount[this.currency.Code]) {
                    db.Url[index] = this.handlePrice(db.Url[index],
                        db.Amount[this.currency.Code], this.currency.Symbol, this.currency.Code);
                }
            }
        });
        return dynBanner;
    }

    elementToPixels(element) {
        const panel_width = this.banner_width + this.banner_margin;
        return Math.round(element) * panel_width;
    }

    centerCurrentElement() {
        const date = new Date();
        this.lastScrollTime = date.getTime();
        this.stopAnimations = false;
        const panel_width = this.banner_width + this.banner_margin;
        const element = this.newScrollLeft / panel_width;
        const position = this.elementToPixels(element);
        this.smoothScroll(position - (window.innerWidth / 2) + (panel_width * 1.5), 0);
    }

    handleMouseenter() {
        this.preventScrollByHover = true;
    }

    handleMouseleave() {
        this.preventScrollByHover = false;
    }

    ngAfterViewInit() {
        if (window.innerWidth >= 991) {
            setTimeout(() => {
                this.centerCurrentElement();
            }, 1750);
        }
    }

    autoCenterCurrentElement() {
        const panel_width = this.banner_width + this.banner_margin;
        setTimeout(() => {
            this.centerCurrentElement();
            if (Math.round(this.newScrollLeft / panel_width) <= 1) {
                this.autoCenterCurrentElement();
            }
        }, 50);
    }

    setSizes() {
        this.banner_width = 2000;
        this.banner_margin = 0;
        if ((this.banner_width + this.banner_margin) > window.innerWidth) {
            this.banner_width = window.innerWidth;
            this.banner_margin = 0;
        }
    }

    fancyScroll(event) {
        if (this.banner_width || this.banner_width <= 0) {
            this.setSizes();
        }
        this.preventScrollByClick = false;
        this.infinityScroll();
        this.isActive();
        this.isDisplayedBanner();
        // this.lazyLoad();
        this.itsScrollOrNot();
        const date = new Date();
        this.lastScrollTime = date.getTime();
        if (window.innerWidth < 991) {
            this.whichBulletShouldBe();
        }
    }

    whereIsScroll() {
        const panel_width = this.banner_width + this.banner_margin;
        const fancyBannerScrollLeft = this.newScrollLeft;
        const firstItem = (this.bannerData.length / 3) + 1;
        const lastItem = (this.bannerData.length / 3) * 2;
        let currentItem = Math.round(fancyBannerScrollLeft / panel_width);
        if (currentItem < firstItem) {
            currentItem = lastItem - currentItem;
        }
        if (this.currentItem !== currentItem) {
            this.currentItem = currentItem;
        }
    }

    transitionOnScroll() {
        const panel_width = this.banner_width + this.banner_margin;
        const fancyBannerScrollLeft = this.newScrollLeft;
        const visibleStart = fancyBannerScrollLeft;
        const visibleStop = visibleStart + window.innerWidth;

        for (let i = 1; i <= this.panels_counter; i++) {
            const panelStop = i * panel_width;
            const panelStart = panelStop - panel_width;
            if (panelStop > visibleStart && panelStart < visibleStop) {
                const panelCenter = (panelStop - panel_width / 2);
                const carouselCenter = (visibleStop - window.innerWidth / 2);
                this.percent_tabs[i] = (((carouselCenter - panelCenter + window.innerWidth) / window.innerWidth)) * 50;
            }
        }
    }

    infinityScroll() {
        const fancyBannerScrollLeft = this.newScrollLeft;
        const fancyBannerScrollRight = fancyBannerScrollLeft + window.innerWidth;
        const panel_width = this.banner_width + this.banner_margin;
        if (this.bannerData) {
            const middleStart = panel_width * (this.bannerData.length / 3);
            const middleStop = middleStart * 2;

            if (fancyBannerScrollRight <= middleStart && !this.stopAnimationsAfterInit) {
                this.stopAnimationsIS = true;
                this.setMobilePosition(panel_width * ((this.bannerData.length / 3) - 1));
                setTimeout(() => {
                    this.stopAnimationsIS = false;
                }, 100);
            }

            if (fancyBannerScrollLeft >= middleStop && !this.stopAnimationsAfterInit) {
                this.stopAnimationsIS = true;
                this.setMobilePosition(fancyBannerScrollLeft - middleStart);
                this.goToSolide(this.dynamicBanner.length + 1);
                setTimeout(() => {
                    this.stopAnimationsIS = false;
                }, 100);
            }
        }
        this.isDisplayedBanner();
    }

    runCarousel() {
        if (window.innerWidth < 991) {
            this.dataSuccesfull = true;
        }
    }

    autoLoop() {
        let date = new Date();
        if (this.loop > 0 && !this.onlyOnce) {
            this.onlyOnce = true;
            setInterval(() => {
                date = new Date();
                if ((!this.preventScrollByHover && (date.getTime() - this.lastScrollTime) >= (this.loop * 1000)) || !this.mobilePosition) {
                    this.nextPanel();
                    this.isDisplayedBanner();
                }
            }, 500);
        }
    }

    nextPanel() {
        if (window.innerWidth >= 991) {
            const panel_width = this.banner_width + this.banner_margin;
            let currentPosition = (Math.floor(this.newScrollLeft / panel_width)) * panel_width;
            currentPosition = currentPosition + (panel_width / 2) - (window.innerWidth / 2);
            let step = panel_width;
            const x = this.newScrollLeft - currentPosition - panel_width;
            step = step - x;
            this.smoothScroll(this.newScrollLeft,
                step);
        } else {
            const date = new Date();
            this.lastScrollTime = date.getTime();
            if (this.mobilePosition) {
                this.gridMoveFor--;
            }
            this.mobilePosition = (100 * this.gridMoveFor);
            setTimeout(() => {
                this.lastScrollTime = date.getTime();
                if (Math.abs(this.gridMoveFor) >= (this.dynamicBanner.length * 2)) {
                    this.mobileGoToFirst();
                }
            }, 501);
            this.whichBulletShouldBe();
            this.isDisplayedBanner();
        }
    }

    goToSolide(whichOne) {
        const panel_width = this.banner_width + this.banner_margin;
        const step = (whichOne * panel_width + panel_width / 2) - this.newScrollLeft - (window.innerWidth / 2);
        if (!this.preventScrollByClick) {
            this.preventScrollByClick = true;
            this.smoothScroll(this.newScrollLeft,
                step);
        }
    }

    smoothScroll(start, step) {
        let panel_width = this.banner_width + this.banner_margin;
        if (step > panel_width) {
            step = panel_width;
        }
        let onlyOnce = false;
        let startStep = start + step;
        if (window.innerWidth >= 991) {
            if (!this.firstMove) {
                startStep = start;
                this.firstMove = true;
            }
            this.newPosition = -100 * (startStep / window.innerWidth);
            if (this.currentPosition !== this.newPosition) {
                this.setMobilePosition(startStep);
                const date = new Date();
                this.lastScrollTime = date.getTime();
            }
        }
        if (window.innerWidth >= 991) {
            setTimeout(() => {
                panel_width = this.banner_width + this.banner_margin;
                if (Math.round(this.newScrollLeft / panel_width) === 3) {
                    if (onlyOnce) {
                        this.triggerLetGo();
                        onlyOnce = false;
                    }
                }
            }, 501);
            setTimeout(() => {
                onlyOnce = true;
            }, 1500);
        }
    }

    handleGoToSlide(i) {
        const cnt = this.panels_counter / 3;
        this.goToSolide(i + cnt);
    }

    counter(i: number) {
        return new Array(i);
    }

    parallax(percent, speed, reverse) {
        if (!this.lotteryService.isMobile) {
            if (reverse) {
                percent = (percent - 100) * (-1);
            }
            percent = percent * speed;
        } else {
            percent = 50;
        }
        return percent;
    }

    trippleForInfinityScroll(things) {
        const tmp = [];
        for (let n = 0; n < 3; n++) {
            things.forEach(function (value) {
                tmp.push(value);
            });
        }
        return tmp;
    }

    cta(action, actionValue, gameBackground) {
        this.actionSpinner = action;
        this.actionValueSpinner = actionValue;
        if (action === 'play_game') {
            this.gameLauncher.gameId = actionValue;
            this.runGame(actionValue, 0.1);
            this.subscriptionsService.emitGameBackground(gameBackground);
        } else if (action === 'add_package') {
            this.buyPackage(actionValue);
        } else if (action === 'deposit') {
            this.gameLauncher.gameId = actionValue;
            this.triggerDeposit();
        } else if (action === 'registration') {
            this.subscriptionsService.emitFakeCart(true);
            this.goToRegistration();
        } else if (action === 'open_url') {
            const av = actionValue.split('?');
            av[0] = av[0].replace('/', '');
            this.router.navigate(['/' + this.showLang, av[0]]).then(() => {
                const url = window.location.toString().split('?');
                window.history.pushState('', '', url[0] + '?' + av[1]);
                const params = av[1].split('&');
                const sendParams = [];
                params.forEach((element, index) => {
                    const param = element.split('=');
                    sendParams[param[0]] = param[1];
                });

                if (sendParams && sendParams['incentiveCode'] && this.userService.userData) {
                    setTimeout(() => {
                        this.userService.sendSomeCookies(sendParams['incentiveCode']).then(val => {
                            this.paramsService.checkForParams(sendParams);
                            this.actionService.goToAction(sendParams, this.showLang, this.userService.userData);
                        });
                    }, 100);
                } else {
                    this.paramsService.checkForParams(sendParams);
                    this.actionService.goToAction(sendParams, this.showLang, this.userService.userData);
                }
            });
        }
    }

    runGame(gameId, minBet) {
        this.preLoginGameStatus = false;
        this.subscriptionsService.emitFakeCart(true);
        this.gameLauncher.runGame(gameId, minBet);
    }

    goToRegistration() {
        localStorage.setItem('isOpenRegister', 'true');
        this.renderer.addClass(document.body, 'modal-open-register');
        setTimeout(() => {
            localStorage.removeItem('isOpenRegister');
        }, 50);
        this.subscriptionsService.emitFakeCart(true);
        this.subscriptionsService.emitRegister(true);
        this.subscriptionsService.emitLogin(false);
    }

    buyPackage(id) {
        const playerShares = localStorage.getItem('playerShares') === '1' ? '&playerShares=' + 1 : '';
        this.isLoadingButton = true;
        const DataString = localStorage.getItem('playerDetails');
        const dataJson = JSON.parse(DataString);
        let membId = 0;
        let sessionId = '';
        let data = '';
        if (DataString != null) {
            membId = dataJson.MemberID;
            sessionId = dataJson.sessionId;
            data = 'sessionId=' + sessionId + '&packageId=' + id + playerShares;
        } else {
            membId = 0;
            data = 'sessionId=0&packageId=' + id;
        }
        data += '&currency=' + this.currency;
        this.lotteryService.postData(globals.appDomain + '/cart/addSingleTicket/' + membId + '/cartAddSingleTicket.json', data)
            .subscribe(
                result => {
                    if (result.addCartMessage.ErrorID !== undefined) {
                        this.isLoadingButton = false;
                    } else {
                        const cartItem = result.addCartMessage;
                        const thisCart = [];
                        const lastItem = cartItem.Cart.Packages.pop();
                        thisCart.push(lastItem);
                        const storedCart = localStorage.getItem('cart');
                        if (storedCart === null) {
                            localStorage.setItem('cart', JSON.stringify(thisCart));
                            this.updateCartLength();
                        } else {
                            const newStoredCart = JSON.parse(storedCart);
                            newStoredCart.push(thisCart[0]);
                            localStorage.setItem('cart', JSON.stringify(newStoredCart));
                            this.updateCartLength();
                        }
                        this.router.navigate(['/' + localStorage.getItem('pageLanguage'), 'cart']);
                    }
                }
            );
    }

    updateCartLength(): void {
        let cart = localStorage.getItem('cart');
        cart = JSON.parse(cart);
        if (cart.length > 0) {
            this.subscriptionsService.updateCart(cart.length);
            this.router.navigate(['/' + localStorage.getItem('pageLanguage'), 'cart']);
        }
    }

    runAddPM() {
        this.goToRegistration();
        this.subscriptionsService.onlyPmStep(true);
        this.disableButton = true;
    }

    itsScrollOrNot() {
        let time = 500;
        if (window.innerWidth < 991) {
            time = Math.round(window.innerWidth * 1.3);
        }
        if (!this.scrollOrNotTmp) {
            this.scrollOrNotTmp = 0;
        }
        setTimeout(() => {
            if (this.scrollOrNotTmp === this.newScrollLeft && !this.scrollOrNotBool) {
                this.scrollOrNotBool = true;
                this.triggerLetGoIfYouCan();
                setTimeout(() => {
                    this.scrollOrNotBool = false;
                }, time);
            }
        }, time);
        this.scrollOrNotTmp = this.newScrollLeft;
    }

    triggerDeposit() {
        this.tbpulse = 'pulse';
        this.hideMenu = false;
        setTimeout(() => {
            this.tbpulse = '';
        }, 125);
        this.subscriptionsService.emitToggleContent(false);
        this.user = JSON.parse(localStorage.getItem('playerDetails'));
        const result = this.gpmData || this.getpmService.gpm_tmp;
        if (result.message.PaymentOptions.length) {
            this.subscriptionsService.emitUserNeedIncreseBalance(-1);
            this.subscriptionsService.emitForceStepTwo(true);
        } else {
            this.runAddPM();
        }
    }

    isActive() {
        /* @todo: co za debil to pisal? */
        const panel_width = this.banner_width + this.banner_margin;
        const fancyBannerScrollLeft = this.newScrollLeft;
        let pos = fancyBannerScrollLeft / panel_width;
        if (pos > (this.dynamicBanner.length * 2)) {
            pos = pos - this.dynamicBanner.length;
        } else if (pos < this.dynamicBanner.length) {
            pos = pos + this.dynamicBanner.length;
        }
        pos = pos - this.dynamicBanner.length;
        if (pos === 0) {
            pos = 1;
        }
        this.activePanel = Math.ceil(pos);
    }

    isDisplayedBanner() {
        if (window.innerWidth >= 991) {
            const panel_width = this.banner_width + this.banner_margin;
            const fancyBannerScrollLeft = this.newScrollLeft;
            const pos = fancyBannerScrollLeft / panel_width;
            this.displayedBanner = Math.ceil(pos);
        } else {
            this.displayedBanner = Math.abs(this.gridMoveFor);
        }
    }

    initLazyLoad() {
        for (let n = 0; n < this.bannerData.length; n++) {
            this.bgsForLazy[n] = 'url(' + this.bannerData[n].FilePath[this.showLang] + ')';
        }
    }

    whichBulletShouldBe() {
        this.whichBullet = (this.gridMoveFor * -1) - this.dynamicBanner.length;
        if (this.whichBullet >= this.dynamicBanner.length) {
            this.whichBullet = this.whichBullet - this.dynamicBanner.length;
        }
        if (this.whichBullet < 0) {
            this.whichBullet = this.whichBullet + this.dynamicBanner.length;
        }
    }

    prevKey(e) {
        e.preventDefault();
    }

    loaderIsDone(bg) {
        if (!bg || bg.indexOf('url(') === -1) {
            return false;
        } else {
            return true;
        }
    }

    handleNewLines(txt) {
        if (txt) {
            return txt.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '<br/>');
        } else {
            return txt;
        }
    }

    handlePrice(txt, price, symbol, code) {
        const pric = price.split('.');
        let digitsinfo = '0.0';
        if (pric[1]) {
            digitsinfo = '0.' + pric[1].length;
        }
        if (price && symbol && code && this.subscriptionsService.countryCodeValue) {
            return txt.replace('<price>', this.currencyPipe.transform(+price, code, symbol, digitsinfo, this.subscriptionsService.countryCodeValue));
        } else {
            return txt;
        }
    }

    centerThisItem(index) {
        this.goToSolide(index);
        setTimeout(() => {
            this.preventScrollByClick = false;
        }, 300);
    }
}
